module.exports = __webpack_public_path__ + "img/loading.41b75b0e.gif";